<app-error-tooltip
  *ngIf="componentStore.error$ | async as error"
  [error]="error"
></app-error-tooltip>

<ng-container *ngIf="componentStore.loaded$ | async">
  <div class="block-nnki-title hidden sm:flex mb-12">
    <div class="swiper-nav">
      <div class="swiper-button-prev" id="prev-featuredTestimonies">
        <app-svg-icon icon="icon-swiper-prev" [width]="10"></app-svg-icon>
      </div>
      <div class="swiper-button-next" id="next-featuredTestimonies">
        <app-svg-icon icon="icon-swiper-next" [width]="10"></app-svg-icon>
      </div>
    </div>
  </div>

  <div class="block-with-slider">
    <div #swiper class="swiper">
      <div class="swiper-wrapper">
        <div
          *ngFor="let testimony of componentStore.entities$ | async; let index = index"
          class="swiper-slide"
        >
          <app-featured-testimony-card
            [featuredTestimony]="testimony"
            [index]="index"
          ></app-featured-testimony-card>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<app-loader-infinite-scroll [loading$]="componentStore.loading$"></app-loader-infinite-scroll>
